import { settlementConstants as constants } from "../../constants/settlement";

const initialState = {
  allData: [],
  data: [],
  total: 1,
  params: {},
  selectedData: null,
  isError: null,
  error: "",
};

const webSettlementReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.GET_ALL_WEB:
      return {
        ...state,
        isError: false,
        allData: action.data,
        total: action.data.count,
      };
    case constants.GET_WEB_SUCCESS:
      return {
        ...state,
        isError: false,
        data: action.data,
        total: action.data.length,
      };

    case constants.GET_WEB_FAILURE:
      return { ...state, isError: true, error: action.error };

    case constants.INSERT_WEB_SUCCESS:
      return {
        ...state,
        isError: false,
        error: "",
      };

    case constants.SELECTED_WEB:
      return {
        ...state,
        isError: false,
        selectedData: action.data,
      };

    case constants.INSERT_WEB_FAILURE:
      return { ...state, isError: true, error: action.error };

    case constants.CLEAR_DATA:
      return { ...state, isError: null, error: "", selectedData: null };

    default:
      return { ...state };
  }
};
export default webSettlementReducer;
